import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

function CheckboxField({ fieldInfo, parentIndex, entityID, CustomFieldID, fieldResponseKey, multiFormIndex, answerContext }) {
    const { register, setValue } = useFormContext();

    useEffect(() => {
        if (entityID) {
            setValue(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.entity_id`, entityID);
        }
    }, [entityID]);

    useEffect(() => {
        if (CustomFieldID) {
            setValue(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.custom_field_id`, CustomFieldID);
        }
    }, [CustomFieldID]);

    useEffect(() => {
        if (fieldResponseKey) {
            setValue(`${fieldResponseKey}.${parentIndex}.answers.${0}.answer_context`, answerContext);
        }
    }, [fieldResponseKey])

    return (
        <>
            <label className="form-control-label d-flex align-items-center text-bold">
                <input {...register(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.boolean_value`)} className="me-1" type="checkbox" />
                {fieldInfo?.field_label}</label>
            {
                fieldInfo?.field_description ?
                    <p className='text-secondary f-12-small'>{fieldInfo?.field_description}</p> : ''
            }
            
            {
                CustomFieldID ?
                    <input type='hidden' {...register(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.custom_field_id`, {
                        value: CustomFieldID
                    })} /> : ''
            }
            {
                entityID ?
                    <input type='hidden' {...register(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.entity_id`, {
                        value: entityID
                    })} /> : ''
            }
        </>
    );
}

export default CheckboxField;